import * as React from "react"
const IdSettingsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 17V3.5C9 2 8 1 6.5 1h-3C2 1 1 2 1 3.5V17c0 .27.03.54.08.8.029.131.062.261.1.39M9 17c0 1.08-.44 2.07-1.14 2.79M9 17V7.34l2.71-2.71c1.06-1.06 2.48-1.06 3.54 0l2.12 2.12c1.06 1.06 1.06 2.48 0 3.54L14.66 13m-6.8 6.79-.04.04c-.09.09-.19.18-.28.25-.3.26-.64.46-.99.6-.11.05-.22.09-.33.13-.39.13-.81.19-1.22.19m2.86-1.21 6.8-6.79M5 21c-.27 0-.54-.03-.8-.08-.13-.03-.26-.06-.39-.1M5 21h13.5c1.5 0 2.5-1 2.5-2.5v-3c0-1.5-1-2.5-2.5-2.5h-3.84M3.81 20.82c-.16-.05-.31-.1-.46-.17 0-.01 0-.01-.01 0-.28-.14-.55-.3-.8-.49l-.01-.01c-.13-.1-.25-.2-.36-.32m1.64.99c-.6-.18-1.17-.51-1.64-.99m1.64.99a4.02 4.02 0 0 1-2.63-2.63m.99 1.64c-.11-.12-.22-.24-.33-.37-.19-.25-.35-.52-.49-.8.01-.01.01-.01 0-.01 0 0 0-.01-.01-.02-.06-.14-.11-.29-.16-.44m.99 1.64c-.48-.47-.81-1.04-.99-1.64M5 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
)
export default IdSettingsIcon